import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import SectionHeader from "../components/SectionHeader";
import YouTubeEmbed from "../components/YouTubeEmbed";

export default function FilmsPage() {
  const [films, setFilms] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    document.title = "Films — Je Ke Pictures";
    api.get("/films").then(r => setFilms(r.data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-32" data-testid="films-page">
      <SectionHeader eyebrow="Our Cinema" title="Films" subtitle="Every frame a poster, every scene a memory. Explore our slate of features and upcoming productions." />
      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8">
        {films.map((f, idx) => {
          const span = idx % 5 === 0 ? "md:col-span-8 md:row-span-2" : idx % 3 === 0 ? "md:col-span-4" : "md:col-span-4";
          return (
            <article
              key={f.id}
              className={`${span} group cursor-pointer border border-white/5 hover:border-[color:var(--jk-gold)]/40 transition-all duration-500 overflow-hidden`}
              onClick={() => setActive(f)}
              data-testid={`film-card-${f.id}`}
            >
              <div className="relative aspect-[3/4] md:aspect-[16/12] bg-[#0a0a0a] overflow-hidden">
                <img
                  src={f.poster_url || `https://img.youtube.com/vi/${f.trailer_youtube_id}/maxresdefault.jpg`}
                  alt={f.title}
                  className="w-full h-full object-cover opacity-60 group-hover:opacity-90 group-hover:scale-105 transition-all duration-700"
                />
                <div className="absolute inset-0" style={{background: "linear-gradient(to top, #050505 0%, transparent 60%)"}}/>
                <div className="absolute bottom-0 left-0 p-6 md:p-8">
                  <div className="font-cinzel text-[0.65rem] tracking-[0.3em] text-[color:var(--jk-gold)] uppercase mb-2">
                    {f.status} {f.year && `· ${f.year}`}
                  </div>
                  {f.title_hindi && (
                    <div className="font-hindi text-2xl md:text-3xl mb-1">{f.title_hindi}</div>
                  )}
                  <h3 className="font-cinzel font-bold text-xl md:text-2xl italic text-white">{f.title}</h3>
                </div>
              </div>
            </article>
          );
        })}
      </div>

      {active && (
        <div className="fixed inset-0 z-[60] bg-black/90 backdrop-blur-xl flex items-center justify-center p-4 overflow-y-auto" onClick={() => setActive(null)} data-testid="film-modal">
          <div className="max-w-4xl w-full jk-glass p-6 md:p-10 my-10" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-start mb-6 gap-4">
              <div>
                {active.title_hindi && <div className="font-hindi text-2xl mb-1">{active.title_hindi}</div>}
                <h2 className="font-cinzel font-bold text-3xl italic text-[color:var(--jk-gold)]">{active.title}</h2>
              </div>
              <button onClick={() => setActive(null)} className="text-white hover:text-[color:var(--jk-gold)]" data-testid="close-film-modal">✕</button>
            </div>
            {active.trailer_youtube_id && <YouTubeEmbed videoId={active.trailer_youtube_id} title={active.title} className="mb-6" />}
            <p className="text-[color:var(--jk-muted)] leading-relaxed mb-6">{active.synopsis}</p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
              {active.director && <div><span className="text-[color:var(--jk-gold)] font-cinzel tracking-wider mr-2">DIRECTOR</span>{active.director}</div>}
              {active.producer && <div><span className="text-[color:var(--jk-gold)] font-cinzel tracking-wider mr-2">PRODUCER</span>{active.producer}</div>}
              {active.cast?.length > 0 && <div className="md:col-span-2"><span className="text-[color:var(--jk-gold)] font-cinzel tracking-wider mr-2">CAST</span>{active.cast.join(", ")}</div>}
              {active.crew?.length > 0 && <div className="md:col-span-2"><span className="text-[color:var(--jk-gold)] font-cinzel tracking-wider mr-2">CREW</span>{active.crew.join(", ")}</div>}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
